export default function PostTitle({
  title,
}) {
  return (
    <h1 className="text-4xl lg:text-5xl tracking-tight font-bold leading-10 lg:leading-relaxed lg:w-5/6">
      {title}
    </h1>
  );
}
